var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.832 2.92615L10.0397 4.00108L12.7559 4.99504L15.628 3.94919L12.832 2.92615Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59167 7.9856L15.6285 3.94984V10.4695L4.59167 14.5053V7.9856Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59436 2.77368L10.0948 0.762356L12.8165 1.73594L7.31601 3.74726L4.59436 2.77368Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32373 3.75562L10.1935 2.70625V15.6875L7.32373 16.7369V3.75562Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32495 3.7605L4.58934 2.78061V15.7619L7.32495 16.7418V3.7605Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32495 13.4602L4.58934 12.4599V15.7619L7.32495 16.7622V13.4602Z",
    fill: "#EFEEEA",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58972 7.98657L1.87277 6.99307V13.5119L4.58972 14.5054V7.98657Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1926 2.69678L12.8175 1.73692V14.7182L10.1926 15.6781V2.69678Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59192 7.98535L7.32531 6.98585V13.5055L4.59192 14.505V7.98535Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88098 10.2434L4.59269 11.2241L12.8302 8.24267M7.36648 6.9706L12.8113 4.97998",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8302 8.24261L15.6213 7.22949",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87439 6.99146L4.59005 6.00258L7.30618 6.99655L4.59052 7.98542L1.87439 6.99146Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75481 4.80841C8.76654 4.99234 8.6399 5.21991 8.46222 5.31128C8.28453 5.40264 8.13783 5.31561 8.1261 5.13168C8.11437 4.94775 8.241 4.72017 8.41869 4.62881C8.59637 4.53745 8.74308 4.62447 8.75481 4.80841Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47766 1.72974L10.1708 2.69558",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1935 9.19746L7.32373 10.2468L7.32453 16.7608L10.1935 15.6875V9.19746Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8175 8.24058L10.1926 9.20044L10.1927 15.6875L12.8175 14.7184V8.24058Z",
    fill: "white",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2829 13.306C12.2926 13.4587 12.1796 13.6739 11.9961 13.7683C11.8125 13.8627 11.6802 13.7736 11.6704 13.6209C11.6607 13.4682 11.7737 13.253 11.9572 13.1586C12.1407 13.0643 12.2731 13.1533 12.2829 13.306Z",
    fill: "#FEFDFD",
    stroke: "currentcolor",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33032 13.5129L12.8317 11.5059",
    stroke: "currentcolor",
    strokeWidth: 0.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPy);
export default __webpack_public_path__ + "static/media/Py.f2403f1024a16e685ad69c10a4da23c7.svg";
export { ForwardRef as ReactComponent };